export default "__VITE_ASSET__CfacuLFK__"